import { SelectInput } from '@/components/form/fields/select/SelectInput';
import { SidebarMainSection } from '@/components/sidebar/SidebarMainSection';
import { usePartners } from '@/services/api/hooks/partners';
import { useRegions } from '@/services/api/hooks/region';
import { FC } from 'react';
import { useNavigate } from 'react-router';

export const AdminLinks: FC<{
  selectedPartnerId: string;
  onSelectPartnerId: (newVal: string) => void;
}> = ({ selectedPartnerId, onSelectPartnerId }) => {
  const [msps] = usePartners();
  const [regions] = useRegions();

  const options = msps.map(c => {
    const region = regions.find(r => r.id === c.id);
    const name = region ? `${c.name} (${region.code})` : c.name;

    return {
      name,
      id: c.id
    };
  });

  const navigate = useNavigate();
  
  return (
    <>
      <SidebarMainSection sectionUrlIdentifier="manageMsps" title={'MSPs'} to={`/msps/manageMsps`}>
        {options.length > 0 && (
          <SelectInput
            id={'selectedMsp'}
            value={options.find(o => o.id === selectedPartnerId) || null}
            placeholder="Please select"
            onChange={option => {
              onSelectPartnerId(option?.id || '');
              option && navigate(`/msps/${option.id}/companies/companiesList`);
            }}
            options={options}
          />
        )}
      </SidebarMainSection>
    </>
  );
};
